//===images===
import reactIcon from '../../assets/images/project-icons/react.png';
import javaIcon from '../../assets/images/project-icons/java.png';
import flutterIcon from '../../assets/images/project-icons/flutter.png'
// import nodeIcon from '../../assets/images/project-icons/node.png'
//============

const projectList = [
    {
        id: '1',
        name: 'Flying Fish Game',
        technology: 'Java for Android',
        description: 'This is a simple gaming app that I have built with Java.',
        imageUrl: javaIcon,
        projectLink: ""
    },
    {
        id: '2',
        name: 'Hotel Sahan',
        technology: 'Java MVC',
        description: 'Simple app that will suit for a hotel. Through this app, you can manage workers and manage hotel rooms along with payments.',
        imageUrl: javaIcon,
        projectLink: "",
    },
    {
        id: '3',
        name: 'Login App',
        technology: 'Flutter',
        description: 'This project is also built for one of my tutorials. I have used the flutter framework to build this project. As the database application, I have used firebase.',
        imageUrl: flutterIcon,
        projectLink: ""
    },
    {
        id: '4',
        name: 'Robo Friends',
        technology: 'React',
        description: 'A Simple react application to wok on react states. For Every url this app will generate a new robot. Just a fun web app',
        imageUrl: reactIcon,
        projectLink: ""
    },
    {
        id: '5',
        name: 'Budget App',
        technology: 'Flutter',
        description: 'Flutter application that can manage your weekly expenses. This application is highly responsive to all device sizes.',
        imageUrl: flutterIcon,
        projectLink: ""
    },
    {
        id: '6',
        name: 'Meals App',
        technology: 'Flutter',
        description: 'Flutter application that lets you save your favourite meals and categorize according to your preference.',
        imageUrl: flutterIcon,
        projectLink: ""
    },
    {
        id: '7',
        name: 'Shopping App',
        technology: 'Flutter',
        description: 'This app is a demo version of online shopping app. You can save your products and other users can view them.',
        imageUrl: flutterIcon,
        projectLink: ""
    },
    {
        id: '8',
        name: 'Places App',
        technology: 'Flutter',
        description: 'This app lets you add places and you can save them locally in your computer.',
        imageUrl: flutterIcon,
        projectLink: ""
    },
    {
        id: '9',
        name: 'Face Detection App',
        technology: 'React & Node,Express',
        description: 'This is a demo web-application that I have deployed in Heroku. Through this app you can detect faces in a photo.',
        imageUrl: reactIcon,
        projectLink: ""
    },

];

export default projectList;